import { fetchAPI } from '../helpers';
import axios from 'axios';
import AppContext from '../AppContext';

class FileService {
    static uploadFile = (file, filename, groupId, contentType, session, tags, shareable, elementId, progressCallback) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file`,
            method: 'PUT',
            body: {
                filename,
                groupId,
                contentType,
                session,
                tags,
                shareable,
                upload: true,
            },
        }).then(function (data) {
            // console.log('uploadFile',data)
            if (data) {
                let reqURL = data.url;
                var config = {
                    headers: {
                        'Content-Type': contentType,
                    },
                    onUploadProgress: function (progressEvent) {
                        progressCallback({
                            elementId: elementId,
                            fileId: data.fileId,
                            filename: filename,
                            progress: Math.round((progressEvent.loaded * 100) / progressEvent.total),
                        });
                    },
                };
                return axios.put(reqURL, file, config).then((axiosData) => {
                    axiosData.fileData = data;
                    return axiosData;
                });
            } else {
                console.log('Error uploading file');
                return Promise.reject(new Error('Error uploading ' + filename));
            }
        });
    };

    static deleteFile = (fileId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}`,
            method: 'DELETE',
            body: {},
        });
    };

    static replaceFile = (fileId, file, filename, contentType, elementId, progressCallback) => {
        return FileService.updateFile(fileId, {
            filename,
            contentType,
            upload: true,
        }).then(function (data) {
            // console.log('replaceFile', data);
            if (data) {
                let reqURL = data.url;
                var config = {
                    headers: {
                        'Content-Type': contentType,
                    },
                    onUploadProgress: function (progressEvent) {
                        progressCallback({
                            elementId: elementId,
                            fileId: data.fileId,
                            filename: filename,
                            progress: Math.round((progressEvent.loaded * 100) / progressEvent.total),
                        });
                    },
                };
                return axios.put(reqURL, file, config).then((axiosData) => {
                    // axiosData.previewUrl = data.previewUrl;
                    // console.log('axiosData', axiosData);
                    return data;
                });
            } else {
                console.log('Error uploading file');
                return Promise.reject(new Error('Error uploading ' + filename));
            }
        });
    };

    static updateFilename = (fileId, filename) => {
        return FileService.updateFile(fileId, {
            filename,
            upload: false,
        });
    };

    static updateShareable = (fileId, shareable) => {
        return FileService.updateFile(fileId, {
            shareable,
            upload: false,
        });
    };

    static updateFile = (fileId, body) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}`,
            method: 'PUT',
            body,
        });
    };

    static addTagToFile = (fileId, tags) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}/tag`,
            method: 'PUT',
            body: {
                tag: tags,
            },
        });
    };

    static removeTagToFile = (fileId, tag) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}/tag`,
            method: 'DELETE',
            body: {
                tag,
            },
        });
    };

    static changeGroup = (fileId, newGroup) => {
        return FileService.updateFile(fileId, {
            groupId: newGroup,
            upload: false,
        });
    };

    static removeGroup = (fileId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}/group`,
            method: 'DELETE',
            body: undefined,
        });
    };

    static getFiles = (files) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/files`,
            method: 'POST',
            body: {
                files,
            },
        });
    };

    static shareFile = (fileId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}/share`,
            method: 'GET',
        });
    };

    static getFile = (fileId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/${fileId}`,
            method: 'GET',
        });
    };

    static findExistingFiles = (fileSize, eTag) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.FileService}${platformId}/file/check-existing-files`,
            method: 'PUT',
            body: {
                fileSize,
                eTag, //eTag és un md5 del fitxer
            },
        });
    };
}

export default FileService;
